import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'
import { Oauth2ServerConnectionType } from '~/plugins/data-connector/authentication/strategies/oauth2/oauth2.server'

export const ProviderWordpressCommon = {
  key: 'wordpress',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'wordpress',
    authUrl: 'https://public-api.wordpress.com/oauth2/authorize',
    tokenUrl: 'https://public-api.wordpress.com/oauth2/token',
    scopes: ['auth', 'posts'],
  }),
}

export type ProviderWordpressAccountType = {
  access_token: string
  token_type: string
  blog_id: string
  blog_url: string
  scope: string
}

export type ProviderWordpressConnectionType = Oauth2ServerConnectionType & {
  access_token: string
  token_type: string
  blog_id: string
  blog_url: string
  scope: string
}
